<template>
  <span>
    <!-- 轻量化图标 -->
    <img v-if="isSuccess" src="@/CommonDP/assets/projectMg/icon_visual.png" title="轻量化成功"
      class="lightStyle" @click.stop="uploadBimex(row)" />
    <img v-if="isFail" src="@/CommonDP/assets/projectMg/icon_visua_error.png" title="轻量化失败"
      class="lightStyle" @click.stop="uploadBimex(row)" />
    <img v-if="isWaiting" src="@/CommonDP/assets/projectMg/notlightweight.png" title="未轻量化"
      class="lightStyle" @click.stop="uploadBimex(row)" />
    <img v-if="isDealing" src="@/CommonDP/assets/projectMg/Inlightweight.png" title="轻量化中"
      class="lightStyle" style="animation: rotating 2s linear infinite;margin-top:8px" />
  </span>
</template>

<script>
export default {
  props: {
    row: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    isWaiting() {
      const row = this.row;
      return row.status === "1" || row.status === "5" || row.status === "99";
    },
    isSuccess() {
      const row = this.row;
      return row.status === "2" || row.status === "6";
    },
    isFail() {
      const row = this.row;
      return row.status === "3" || row.status === "7";
    },
    isDealing() {
      const row = this.row;
      return row.status === "4" || row.status === "8";
    }
  },

  methods: {
    uploadBimex(row) {
      this.$emit("updateLight", row);
    }
  }
};
</script>
<style lang="scss" scoped>
.lightStyle {
  margin-right: 8px;
  margin-top: 10px;
  cursor: pointer;
}
</style>
